import React from 'react';
import PropTypes from 'prop-types';

import '../styles/Sublist.css';
import Scale from '../elements/Scale';

import { findSubItemClassName, findSubListTopPosition, convertPlusMinus, convertToIconName } from '../helpers/helperFunctions.js';

import {ReactComponent as AwbIcon} from '../icons/awb-icon.svg';
import {ReactComponent as SetAIcon} from '../icons/set-a-icon.svg';
import {ReactComponent as SetBIcon} from '../icons/set-b-icon.svg';
import {ReactComponent as Tungsten} from '../icons/tungsten-icon.svg';
import {ReactComponent as Kelvin} from '../icons/kelvin-icon.svg';
import {ReactComponent as DaylightIcon} from '../icons/daylight-icon.svg';
import {ReactComponent as AddCheckMark} from '../icons/add-check-mark-icon.svg';
import {ReactComponent as AddOkMark} from '../icons/add-ok-mark-icon.svg';

const icons = {
  addCheckMark:  <AddCheckMark className="Icon-topbar" />,
  addOKMark:  <AddOkMark className="Icon-topbar" />,
  setA: <SetAIcon className="Icon-topbar" />,
  setB: <SetBIcon className="Icon-topbar" />,
  aWB: <AwbIcon className="Icon-topbar" />,
  daylight: <DaylightIcon className="Icon-topbar" />,
  kelvin: <Kelvin className="Icon-topbar" />,
  tungsten: <Tungsten className="Icon-topbar" />,
}

const SubList = ({ subList, subItemIndex, parentIndex, rowAmount, subListHasIcons }) => {
    // Find position top for subList element
    const subListTopPosition = findSubListTopPosition(subList.length, parentIndex, rowAmount);

    // Function to convert subItem string to svg if needs or convert plus minus 
    const convertName = (string) => {
      const convertedString = subListHasIcons 
      ? icons[convertToIconName(string)] && convertToIconName(string) !== 'myMenu'
        ? icons[convertToIconName(string)]
        : string
      : convertPlusMinus(string);

      return convertedString;
    }

    // We can show only 8 or 7 lines on menu screen
    // Find elements which will be shown and create className for each
    let itemLineNumber = 0;
    const subItemsToRender = [];

    subList.forEach((subItem, index, array) => {
      if (subItemIndex < rowAmount - 1) {
        if (index <= rowAmount - 1) {
          const subItemClassName = findSubItemClassName(subItemIndex, index, array.length, itemLineNumber, parentIndex, rowAmount);
          subItemsToRender.push({subItem: subItem, className: subItemClassName});
          itemLineNumber += 1;
        }
      } else {
        if (subItemIndex === array.length - 1) {
          if (index > subItemIndex - rowAmount && index <= subItemIndex + 1) {
            const subItemClassName = findSubItemClassName(subItemIndex, index, array.length, itemLineNumber, parentIndex, rowAmount);
            subItemsToRender.push({subItem: subItem, className: subItemClassName});
            itemLineNumber += 1;
          } 
        } else {
          if (index > subItemIndex - rowAmount + 1 && index <= subItemIndex + 1) {
            const subItemClassName = findSubItemClassName(subItemIndex, index, array.length, itemLineNumber, parentIndex, rowAmount);
            subItemsToRender.push({subItem: subItem, className: subItemClassName});
            itemLineNumber += 1;
          } 
        }
      }
    });

    // Render these elements as a list
    return (
        <ul className="Sub-list Sub-list-active" style={{ top: subListTopPosition }}>
          {subItemsToRender.map((el) => <li key={el.subItem} className={el.className}>{convertName(el.subItem)}</li>)}
          {//show scale only if we have more li elements than rows
            subList.length > rowAmount &&
          <Scale 
            parent={"Sublist"} 
            rowAmount={rowAmount}
            listLength={subList.length}
            listItemIndex={subItemIndex}
          />
          }
        </ul>
    );
};
  
SubList.propTypes = {
    subList: PropTypes.arrayOf(PropTypes.string).isRequired,
    subItemIndex: PropTypes.number.isRequired,
    parentIndex: PropTypes.number.isRequired,
    rowAmount: PropTypes.number.isRequired,
    subListHasIcons: PropTypes.bool,
};

export default SubList;